import React from 'react';

const DriverArrived = ({ driver, otpCode }) => {
  return (
    <div className="bg-white text-center hidden md:block">
      {/* Status Image - Bigger Size */}
      <div className="w-full h-80 md:h-96 lg:h-[500px] bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center overflow-hidden">
        <img 
          src="/driverarrived.png" 
          alt="Driver Arrived" 
          className="w-full h-full object-contain"
        />
      </div>
      
      <div className="p-6 md:p-8 border-b border-gray-100">
        <div className="flex flex-col items-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
            Driver Arrived
          </h2>
          <p className="text-gray-600 text-base md:text-lg mb-4 font-semibold">
            {driver?.name || 'Driver'} has arrived at your pickup location
          </p>
          
          {/* Display OTP if available */}
          {/* CRITICAL: Safely extract OTP code to prevent React error */}
          {otpCode && (() => {
            // Helper function to safely extract OTP code from string or object
            const extractOtpCode = (otp) => {
              if (!otp) return null;
              if (typeof otp === 'string' || typeof otp === 'number') {
                return String(otp);
              }
              if (typeof otp === 'object' && otp !== null) {
                return otp.code ? String(otp.code) : null;
              }
              return null;
            };
            
            const safeOtpCode = extractOtpCode(otpCode);
            if (!safeOtpCode) return null;
            
            return (
              <div className="bg-blue-50 rounded-lg px-8 py-6 mb-4 max-w-sm w-full border border-blue-200 notranslate" translate="no">
                <div className="flex items-center justify-center mb-3 notranslate" translate="no">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center notranslate" translate="no">
                    <svg className="w-7 h-7 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                </div>
                <p className="text-blue-700 text-sm font-semibold mb-2 uppercase tracking-wide notranslate" translate="no">Your Pickup OTP</p>
                <p 
                  className="text-blue-900 font-black text-4xl tracking-widest mb-2 notranslate" 
                  translate="no" 
                  lang="en"
                  data-translate="no"
                  style={{ 
                    unicodeBidi: 'isolate', 
                    direction: 'ltr',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none'
                  }}
                  suppressContentEditableWarning={true}
                  contentEditable={false}
                >
                  {String(safeOtpCode).split('').map((digit, idx) => (
                    <span key={idx} className="notranslate" translate="no" lang="en" data-translate="no" style={{ unicodeBidi: 'isolate', direction: 'ltr' }}>{digit}</span>
                  ))}
                </p>
                <p className="text-blue-600 text-xs font-medium mt-3 flex items-center justify-center notranslate" translate="no">
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Share this with the driver at pickup
                </p>
              </div>
            );
          })()}
          
          <div className="bg-gray-50 px-6 py-3 rounded-lg border border-gray-100">
            <p className="text-gray-700 font-medium text-sm flex items-center justify-center space-x-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Please proceed to the pickup location</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverArrived;

